const createAction = (action, type, payload) => {
  action({
    type,
    payload
  });
};

export default createAction;
